"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Calendar = void 0;
var react_1 = __importStar(require("react"));
var calendar_store_1 = require("./calendar-store");
var components_1 = require("./components");
var utils_1 = require("./utils");
function dayClassName(d, viewDate, selected, today) {
    var result = [];
    if (d.getTime() == today.getTime())
        result.push("today");
    if ((selected === null || selected === void 0 ? void 0 : selected.getTime()) == d.getTime())
        result.push("selected");
    if (d.getMonth() != viewDate.getMonth())
        result.push("other-month");
    return result.join(" ");
}
function setDateAction(d, time, onChange) {
    var date = (0, utils_1.cloneDate)(d);
    return function () { return onChange((0, utils_1.dateToStr)(date, time !== null && time !== void 0 ? time : { hour: 0, minute: 0 })); };
}
function Calendar(_a) {
    var className = _a.className, divRef = _a.divRef, timeOnly = _a.timeOnly;
    var _b = (0, react_1.useContext)(calendar_store_1.DatePickerContext), _c = _b.state, date = _c.date, selected = _c.selected, onChange = _c.onChange, time = _c.time, isTimePicker = _c.isTimePicker, timeMode = _c.timeMode, dispatch = _b.dispatch;
    date = date || new Date();
    var hide = (0, calendar_store_1.useHide)();
    function changeAndHide(v) {
        v = v.replace(/^(.{10}).+/g, '$1');
        onChange(v);
        hide();
    }
    var today = (0, react_1.useMemo)(function () {
        var today = new Date();
        return new Date(today.getFullYear(), today.getMonth(), today.getDate());
    }, []);
    var _d = (0, react_1.useMemo)(function () {
        var firstDay = (0, utils_1.firstDayOfMonth)(date);
        var lastDay = (0, utils_1.lastDayOfMonth)(date);
        firstDay = (0, utils_1.dateWalk)(firstDay, -utils_1.DAY, function (d) { return d.getDay() == 0; });
        lastDay = (0, utils_1.dateWalk)(lastDay, utils_1.DAY, function (d) { return d.getDay() == 6; });
        return { lastDay: lastDay, firstDay: firstDay };
    }, [date.getTime()]), lastDay = _d.lastDay, firstDay = _d.firstDay;
    var cells = (0, react_1.useMemo)(function () {
        var dates = (0, utils_1.listUntil)(firstDay, function (d) { return d.getTime() <= lastDay.getTime(); });
        return dates.map(function (d) { return react_1.default.createElement("div", { key: d.getTime(), onClick: setDateAction(d, time, isTimePicker ? onChange : changeAndHide), className: "date ".concat(dayClassName(d, date, selected, today)) }, d.getDate()); });
    }, [firstDay.getTime(), time]);
    var daysOfWeek = (0, react_1.useMemo)(function () {
        return "Dom,Seg,Ter,Qua,Qui,Sex,Sáb".split(",").map(function (w) { return react_1.default.createElement("div", { key: w, className: 'wh' }, w); });
    }, []);
    function nextMonth() {
        var next = (0, utils_1.cloneDate)(date);
        next.setMonth(date.getMonth() + 1);
        dispatch({ type: "setDate", payload: next });
    }
    function prevMonth() {
        var next = (0, utils_1.cloneDate)(date);
        next.setMonth(date.getMonth() - 1);
        dispatch({ type: "setDate", payload: next });
    }
    function changeMode(mode) {
        dispatch({ type: "setMode", payload: mode });
    }
    function pickMinute(minute) {
        var newTime = time !== null && time !== void 0 ? time : { hour: 0, minute: 0 };
        newTime = __assign(__assign({}, newTime), { minute: minute });
        onChange(timeOnly ? (0, utils_1.timeToStr)(newTime) : (0, utils_1.dateToStr)(selected || new Date(), newTime));
        back();
    }
    function pickHour(hour) {
        var newTime = time !== null && time !== void 0 ? time : { hour: 0, minute: 0 };
        newTime = __assign(__assign({}, newTime), { hour: hour });
        onChange(timeOnly ? (0, utils_1.timeToStr)(newTime) : (0, utils_1.dateToStr)(selected || new Date(), newTime));
        back();
    }
    function back() {
        dispatch({ type: "setMode", payload: "display" });
    }
    if (timeOnly) {
        return react_1.default.createElement("div", { ref: divRef, className: "calendar ".concat(className), tabIndex: -1, onClick: function (e) { return e.stopPropagation(); } },
            (timeMode != "hour" && timeMode != "minute") && react_1.default.createElement(components_1.TimeDisplay, { time: time, onClick: changeMode }),
            timeMode == "hour" && react_1.default.createElement(components_1.HourMenu, { time: time, onClick: changeMode, onChange: pickHour, back: back }),
            timeMode == "minute" && react_1.default.createElement(components_1.MinuteMenu, { time: time, onClick: changeMode, onChange: pickMinute, back: back }));
    }
    return react_1.default.createElement("div", { ref: divRef, className: "calendar ".concat(className), tabIndex: -1, onClick: function (e) { return e.stopPropagation(); } },
        (timeMode != "hour" && timeMode != "minute") &&
            react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement("div", { className: 'month-header' },
                    react_1.default.createElement("span", { onClick: nextMonth, className: 'next fa fa-chevron-right' }),
                    react_1.default.createElement("span", { onClick: prevMonth, className: 'prev fa fa-chevron-left' }),
                    " ",
                    utils_1.MONTHS[date.getMonth()],
                    " de ",
                    date.getFullYear()),
                react_1.default.createElement("div", { className: 'week-header' }, daysOfWeek),
                react_1.default.createElement("div", { className: 'days' }, cells),
                isTimePicker && react_1.default.createElement(components_1.TimeDisplay, { time: time, onClick: changeMode })),
        timeMode == "hour" && react_1.default.createElement(components_1.HourMenu, { time: time, onClick: changeMode, onChange: pickHour, back: back }),
        timeMode == "minute" && react_1.default.createElement(components_1.MinuteMenu, { time: time, onClick: changeMode, onChange: pickMinute, back: back }));
}
exports.Calendar = Calendar;
//# sourceMappingURL=calendar.js.map